(function () {
  const PHONE_NUMBER = "020 3004 5451";
  const PHONE_LINK = `<a href="tel:02030045451" style="text-decoration: underline; color: inherit;">${PHONE_NUMBER}</a>`;

  // England & Wales bank holidays for 2026
  const UK_BANK_HOLIDAYS_2026 = new Set([
    "2026-01-01",
    "2026-04-03",
    "2026-04-06",
    "2026-05-04",
    "2026-05-25",
    "2026-08-31",
    "2026-12-25",
    "2026-12-28"
  ]);

  function getUKTimeNow() {
    const now = new Date();
    const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
    const londonOffset = isBST(new Date(utc)) ? 1 : 0;
    return new Date(utc + londonOffset * 60 * 60 * 1000);
  }

  function isBST(date) {
    const year = date.getUTCFullYear();
    const marchLastSunday = new Date(Date.UTC(year, 2, 31));
    marchLastSunday.setUTCDate(31 - marchLastSunday.getUTCDay());
    const octoberLastSunday = new Date(Date.UTC(year, 9, 31));
    octoberLastSunday.setUTCDate(31 - octoberLastSunday.getUTCDay());
    return date >= marchLastSunday && date < octoberLastSunday;
  }

  function getOrdinalSuffix(n) {
    if (n > 3 && n < 21) return "th";
    switch (n % 10) {
      case 1: return "st";
      case 2: return "nd";
      case 3: return "rd";
      default: return "th";
    }
  }

  function toUKDateKey(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  function isWeekend(date) {
    const day = date.getDay();
    return day === 0 || day === 6;
  }

  function isBankHoliday(date) {
    return UK_BANK_HOLIDAYS_2026.has(toUKDateKey(date));
  }

  function isWorkingDay(date) {
    return !isWeekend(date) && !isBankHoliday(date);
  }

  function addWorkingDays(startDate, days) {
    const date = new Date(startDate);

    while (days > 0) {
      date.setDate(date.getDate() + 1);
      if (isWorkingDay(date)) {
        days--;
      }
    }

    return date;
  }

  function getNextWorkingDay(startDate) {
    const date = new Date(startDate);

    do {
      date.setDate(date.getDate() + 1);
    } while (!isWorkingDay(date));

    return date;
  }

  function formatDate(date) {
    const day = date.getDate();
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return day + getOrdinalSuffix(day) + " " + monthNames[date.getMonth()];
  }

  function getTruckSVG(className = "") {
    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="truck-icon ${className}">
      <path d="M3 16c0 .55.45 1 1 1h1a2 2 0 1 0 4 0h6a2 2 0 1 0 4 0h1a1 1 0 0 0 1-1v-5a1 1 0 0 0-.293-.707l-3-3A1 1 0 0 0 18 7H15V4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12zM5 7h9v3H5V7z"/>
    </svg>`;
  }

  function extractMinMax(rulesEl) {
    const text = (rulesEl?.innerText || rulesEl?.textContent || "").trim();
    const match = text.match(/Standard:\s*(\d+)\s*[-–]\s*(\d+)\s*Working Day Delivery/i);
    if (!match) return null;

    return {
      minDays: parseInt(match[1], 10),
      maxDays: parseInt(match[2], 10)
    };
  }

  function renderBox(box, rulesEl) {
    const parsed = extractMinMax(rulesEl);
    if (!parsed) return;

    const { minDays, maxDays } = parsed;

    const nowUK = getUKTimeNow();
    const weekday = nowUK.getDay();
    const sameDayCutoff = new Date(nowUK);
    sameDayCutoff.setHours(12, 0, 0, 0);

    // Start counting standard delivery from the next working day
    const standardStartCountDate = getNextWorkingDay(nowUK);
    const standardStartDate = addWorkingDays(standardStartCountDate, minDays - 1);
    const standardEndDate = addWorkingDays(standardStartCountDate, maxDays - 1);

    // Express should also land on the next working day
    const expressDate = getNextWorkingDay(nowUK);

    // Same-day only on working weekdays before cutoff, and not on a bank holiday
    const showSameDay =
      weekday >= 1 &&
      weekday <= 5 &&
      nowUK < sameDayCutoff &&
      isWorkingDay(nowUK);

    const sameDayDate = new Date(nowUK);

    let message = `<ul>
      <li>${getTruckSVG()}<strong>Standard Delivery:</strong> Est between <strong>${formatDate(standardStartDate)}</strong> and <strong>${formatDate(standardEndDate)}</strong> – <em>Cut-off time: 3pm</em>.</li>
      <li>${getTruckSVG("truck-express")}<strong>Express Delivery:</strong> <strong>${formatDate(expressDate)}</strong> – Call ${PHONE_LINK} to enquire.</li>
    `;

    if (showSameDay) {
      message += `<li>${getTruckSVG("truck-sameday")}<strong>Same Day Delivery:</strong> <strong>${formatDate(sameDayDate)}</strong> – Call ${PHONE_LINK} to enquire.</li>`;
    }

    message += `</ul>`;

    const target = box.querySelector(".delivery-lines");
    if (target) target.innerHTML = message;
  }

  function initEstimatedDelivery(root = document) {
    root.querySelectorAll(".estimated-delivery").forEach((box) => {
      if (box.dataset.edInit === "1") return;

      const rulesEl =
        box.parentElement?.querySelector(".delivery-rules") ||
        box.querySelector(".delivery-rules");

      if (!rulesEl) return;

      renderBox(box, rulesEl);
      box.dataset.edInit = "1";
    });
  }

  document.addEventListener("DOMContentLoaded", () => {
    initEstimatedDelivery(document);
  });

  document.addEventListener("on:cart:add", () => {
    document.querySelectorAll(".estimated-delivery").forEach((b) => delete b.dataset.edInit);
    initEstimatedDelivery(document);
  });

  document.addEventListener("on:line-item:change", () => {
    document.querySelectorAll(".estimated-delivery").forEach((b) => delete b.dataset.edInit);
    initEstimatedDelivery(document);
  });
})();